import { render, staticRenderFns } from "./RemoveWhiteBG.vue?vue&type=template&id=6f64e17a&"
import script from "./RemoveWhiteBG.vue?vue&type=script&lang=js&"
export * from "./RemoveWhiteBG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports